const translations = {
  es: {
    back: "Volver",
    completePayment: "Completar Pago",
    service: "Servicio",
    loadingForm: "Preparando formulario de pago...",
    successPayment: "🎉 Pago realizado con éxito",
    confirmError: "El pago se procesó, pero hubo un problema confirmándolo.",
    paymentError: "Error procesando el pago. Intente nuevamente.",
    missingData: "Faltan datos del backend",
    creatingIntentError: "Error creando intención de pago",
    sdkLoaded: "✅ SDK de Onvo cargado correctamente",
    paymentProcessed: "El pago se procesó correctamente",
  },
  en: {
    back: "Back",
    completePayment: "Complete Payment",
    service: "Service",
    loadingForm: "Preparing payment form...",
    successPayment: "🎉 Payment completed successfully",
    confirmError: "The payment was processed, but there was a problem confirming it.",
    paymentError: "Error processing the payment. Please try again.",
    missingData: "Missing data from backend",
    creatingIntentError: "Error creating payment intent",
    sdkLoaded: "✅ Onvo SDK loaded successfully",
    paymentProcessed: "The payment was successfully processed",
  },
};
export default translations